import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * Redirect-Route von /events/:eventId nach /tickets/:eventId.
 * Sorgt dafür dass alte Event-Detail-Links weiterhin funktionieren.
 */
export const Route = createFileRoute('/events/$eventId')({
  beforeLoad: ({ params }) => {
    throw redirect({ to: '/tickets/$eventId', params: { eventId: params.eventId }, replace: true });
  },
  component: () => null,
});
